module.exports = __webpack_public_path__ + "img/infodump.302f0218.png";